<div class="ba-field-group">
    <div class="centered">
        <img class="img-see-more-less" [src]="asset('assets/images/generico-alerta.svg')" alt="generico alerta">
    </div>
</div>
<p class="ibk-description">
    El c&oacute;digo ingresado es incorrecto
</p>
<div class="ba-field-group centered">
    <span>Te quedan {{numberOfAttemptsOtpCode}} {{descriptionAttempts}}.</span>
</div>
<ibk-button class="ba-action" [loading]="isLoading">
    <button id="btn-resend-code" class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn"
        (click)="resendCodeViewOtpError()">
        Reenviar c&oacute;digo
    </button>
</ibk-button>
<ibk-button class="ba-action" [loading]="isLoading">
    <button id="btn-exit" class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn btn-white-primary"
        (click)="exitViewOtpError()">
        Salir
    </button>
</ibk-button>